module.exports = __webpack_public_path__ + "img/title2.322bbc33.png";